import { AccountContactFormValues, accountContactFormDefaultValues } from '../ui/dialogs/accountContactFormSchema';
import {
  AddressInput,
  AddressEntity,
  AccountContactEntity,
  CreateAccountContactInput,
  UpdateAccountContactInput,
} from '../api/contact/types';

const mapAddressEntityToForm = (address: AddressEntity | null | undefined) => ({
  streetAddress: address?.address ?? '',
  city: address?.city ?? '',
  state: address?.stateProvince ?? '',
  zip: address?.postalCode ?? '',
  country: address?.country ?? 'US',
});

export const mapContactEntityToFormValues = (contact: AccountContactEntity): AccountContactFormValues => {
  const contactAddress = contact.contactAddress;
  const deliveryAddress = contact.deliveryAddress;

  const hasSameAddress =
    !deliveryAddress ||
    (contactAddress?.address === deliveryAddress?.address &&
      contactAddress?.city === deliveryAddress?.city &&
      contactAddress?.stateProvince === deliveryAddress?.stateProvince &&
      contactAddress?.postalCode === deliveryAddress?.postalCode &&
      contactAddress?.country === deliveryAddress?.country);

  return {
    ...accountContactFormDefaultValues,
    email: contact.email ?? '',
    phone: contact.phone ?? '',
    title: contact.title ?? '',
    sameAsContact: hasSameAddress,
    lastName: contact.lastName ?? '',
    firstName: contact.firstName ?? '',
    contactAddress: mapAddressEntityToForm(contactAddress),
    deliveryAddress: mapAddressEntityToForm(deliveryAddress),
  };
};

const mapAddressToInput = (address: AccountContactFormValues['contactAddress']): AddressInput => ({
  city: address.city,
  postalCode: address.zip,
  stateProvince: address.state,
  country: address.country ?? 'US',
  address: address.streetAddress || null,
});

const resolveDeliveryAddress = (values: AccountContactFormValues): AddressInput => {
  if (values.sameAsContact) {
    return mapAddressToInput(values.contactAddress);
  }

  return mapAddressToInput(values.deliveryAddress as AccountContactFormValues['contactAddress']);
};

export const mapFormToCreateInput = (
  values: AccountContactFormValues,
  accountId: string
): CreateAccountContactInput => ({
  accountId,
  lastName: values.lastName,
  email: values.email || null,
  phone: values.phone || null,
  firstName: values.firstName,
  deliveryAddress: resolveDeliveryAddress(values),
  contactAddress: mapAddressToInput(values.contactAddress),
});

export const mapFormToUpdateInput = (
  values: AccountContactFormValues,
  contactId: string
): UpdateAccountContactInput => ({
  id: contactId,
  lastName: values.lastName,
  firstName: values.firstName,
  email: values.email || null,
  phone: values.phone || null,
  title: values.title || null,
  deliveryAddress: resolveDeliveryAddress(values),
  contactAddress: mapAddressToInput(values.contactAddress),
});
